import {Route, Switch} from "react-router";

import LohpChooseRole from "./components/lohp-choose-role.tsx";
import LohpLearnerBirthday from "./components/lohp-learner-birthday.tsx";
import LohpSignupOverAgeGate from "./components/lohp-signup-over-age-gate.tsx";
import LohpSignupParent from "./components/lohp-signup-parent.tsx";
import LohpSignupTeacher from "./components/lohp-signup-teacher.tsx";
import LohpSignupUnderAgeGate from "./components/lohp-signup-under-age-gate.tsx";

/**
 * LohpRouter is a nested router for the logged out homepage. It controls the
 * new sign up module which replaces the current hero module.
 * @returns {React.Component<SwitchProps, any>} A react router Switch component
 */
export function LohpRouter() {
    return (
        <Switch>
            <Route
                path="/lohp/learner"
                exact={true}
                component={LohpLearnerBirthday}
            />
            <Route
                path="/lohp/learner/under-age-gate"
                exact={true}
                component={LohpSignupUnderAgeGate}
            />
            <Route
                path="/lohp/learner/over-age-gate"
                exact={true}
                component={LohpSignupOverAgeGate}
            />
            <Route
                path="/lohp/teacher"
                exact={true}
                component={LohpSignupTeacher}
            />
            <Route
                path="/lohp/parent"
                exact={true}
                component={LohpSignupParent}
            />
            <Route path="/" exact={true} component={LohpChooseRole} />
        </Switch>
    );
}

type ModuleProps = {
    kind: "LohpRouterModule";
};

export const LohpRouterModule = ({kind}: ModuleProps): React.ReactElement => {
    return <LohpRouter />;
};
